import { defineRule } from 'vee-validate';
import { required, min } from '@vee-validate/rules';

export function defineVeeValidateGlobalRule() {
  defineRule('required', required);
  defineRule('min', min);
}
